<div class="card m-0 shadow-none">
  <div class="card-header">
    <div class="row align-items-center">
      <div class="col">
        <h5 class="m-0">Reset Mobile App Password</h5>
      </div>
      <div class="col-auto">
        <button
          type="button"
          class="btn p-2"
          (click)="modal.dismiss('Cross click')">
          <i class="bx bx-x font-size-24"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-12">
        <h6>Reset Password</h6>
        <p>
          Enter a new password for this Resident below. The previous password
          will no longer work.
        </p>
      </div>
    </div>

    <form [formGroup]="group" class="row">
      <div class="col-md-6">
        <label for="password"> New Password </label>
        <input
          id="password"
          type="password"
          class="form-control"
          formControlName="password"
          [ngClass]="validate('password')" />
        <span class="text-muted font-size-12 mt-2">
          New password must be at least 8 characters long and include at least
          one number.
        </span>
      </div>
      <div class="col-md-6">
        <label for="passwordConfirmation"> Confirm New Password </label>
        <input
          id="passwordConfirmation"
          type="password"
          class="form-control"
          formControlName="passwordConfirmation"
          [ngClass]="validate('passwordConfirmation')" />
      </div>
    </form>
  </div>

  <div class="card-footer">
    <div class="row justify-content-between">
      <div class="col-auto">
        <button
          (click)="modal.dismiss('Cross click')"
          type="button"
          class="btn btn-sm btn-soft-danger">
          Cancel
        </button>
      </div>
      <div class="col-auto" *ngIf="!passwordSaved">
        <button
          (click)="ngSubmit()"
          type="button"
          class="btn btn-sm btn-primary">
          Save New Password
        </button>
      </div>

      <div class="col-auto" *ngIf="passwordSaved">
        <p class="text-primary">
          <i class="bx bx-check"></i>
          Password Saved!
        </p>
        <button (click)="redirect()" class="btn btn-sm btn-soft-primary">
          Print Username & Password
        </button>
      </div>
    </div>
  </div>
</div>
